import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MenuAsideService, SubheaderService} from '../../../../core/_base/layout';
import {MatDialog} from '@angular/material';
import {PaymentInfoPopup} from '../../../component/popup/payment-info/payment-info.popup';
import {PaymentService} from '../../../../provider/payment.service';

@Component({
  selector: 'kt-card-info',
  templateUrl: './card-info.component.html',
  styleUrls: ['./card-info.component.scss']
})
export class CardInfoComponent implements OnInit {
  deal = true;
  threeDisplay = false;
  threeData: string = null;

  constructor(private subheaderService: SubheaderService,
              private menuAsideService: MenuAsideService,
              public dialog: MatDialog,
              private paymentServ: PaymentService,
              private changeDetect: ChangeDetectorRef
  ) {
    this.menuAsideService.pathname$.next(window.location.pathname);

  }

  ngOnInit() {
    this.subheaderService.title$.next({title: 'App Information', desc: ''});
  }

  openText(type) {
    console.log(type);
    const dialogRef = this.dialog.open(PaymentInfoPopup, {height: '600px', width: '900px', data: type});
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  async postPayment() {
    this.threeDisplay = true;
    try {
      const resp = await this.paymentServ.postPayment(null) as {
        status: string;
        errorCode: string;
        errorMessage: string;
        locale: string;
        systemTime: number;
        conversationId: string;
        threeDSHtmlContent: string;
      }
      ;
      this.threeData = atob(resp.threeDSHtmlContent);
      const iframe = document.getElementById('three-d') as HTMLIFrameElement;
      iframe.style.display = 'block';
      this.changeDetect.detectChanges();
      iframe.contentDocument.write(this.threeData);
      console.log(resp);
    } catch (err) {
      console.error(err);
    }
  }
}
